module.exports = __webpack_public_path__ + "img/b.dd5d1338.png";